<ng-template
  let-extraClass="extraClass"
  #topNav>
  @if (!isRightSideContent) {
    <tidy-top-nav
      [class]="extraClass"
      [title]="cameFromEditAddress ? 'Add Rooms' : 'Create First List'"
      [canGoBack]="true"/>
  }
</ng-template>

<ng-container *ngTemplateOutlet="topNav;context:{ extraClass: 'mobile' }" />

<ng-template #content>
  <tidy-wrapper>
    <ng-container *ngTemplateOutlet="topNav;context:{ extraClass: 'desktop' }" />

    @if (loaded) {
      @if (!cameFromEditAddress) {
        <tidy-row [align]="'center'">
          <tidy-text
            [body]="'Please let us know some detail about the address for this list:'" /><span>&nbsp;</span>
            <tidy-text
              [body]="addressName" />
          </tidy-row>
        }
        @if (cameFromEditAddress) {
          <tidy-row [align]="'center'">
            <tidy-text
              [body]="'Please tell us more about:'" /><span>&nbsp;</span>
              <tidy-text
                [body]="addressName" />
            </tidy-row>
          }
          <tidy-card>
            <form [formGroup]="form">
              <tidy-row class="field-top-padding field-bottom-padding">
                <tidy-select
                  [label]="'Number of Bedrooms'"
                  [icon]="'assets/svg/bed.svg'"
                  [form]="form.controls.beds"
                  formControlName="beds"
                  [items]="roomOptions" />
              </tidy-row>
              <tidy-row class="field-bottom-padding">
                <tidy-select
                  [label]="'Number of Bathrooms'"
                  [icon]="'assets/svg/bed.svg'"
                  [form]="form.controls.baths"
                  formControlName="baths"
                  [items]="roomOptions" />
              </tidy-row>
              <tidy-row>
                <tidy-select
                  [label]="'Number of Floors'"
                  [icon]="'assets/svg/home.svg'"
                  [form]="form.controls.floors"
                  formControlName="floors"
                  [items]="floorOptions" />
              </tidy-row>
            </form>
          </tidy-card>
          <tidy-button
            [text]="cameFromEditAddress ? 'Add Rooms' : 'Create Checklist'"
            [action]="boundSave"
            class="primary" />
        }
      </tidy-wrapper>
    </ng-template>

    @if (!isRightSideContent) {
      <app-scroll-wrapper [templateContent]="content" />
    }

    @if (isRightSideContent) {
      <ng-container *ngTemplateOutlet="content" />
    }
